export const SELECT_ALL_LABEL = 'Open to all'
export const SELECT_ALL_VALUE = 'all'

export const EXCLUDE_LABEL = 'Prefer not to say'
